import { BindingPath } from "../../CoreTypes";
import { IReadonlyModelHunk } from "../IReadonlyModelHunk";
import { AbsoluteResolvedModelPath } from "../../../../../../Common/ModelPath/ModelPath";

export enum ModelActionType {
    SetValues = "SET_VALUES",
    ClearModel = "CLEAR_MODEL",
    redefineModel = "REDEFINE_MODEL",
    MergeRedefinedModel = "MERGE_REDEFINED_MODEL",
    DropRedefinedModel = "DROP_REDEFINED_MODEL",
    AggregatedSetToModel = "AGGREGATED_SET_TO_MODEL",
}

export declare type ModelAction =
    | {
          type: ModelActionType.SetValues;
          payload: {
              values: IReadonlyModelHunk;
              deleted: AbsoluteResolvedModelPath[];
          };
      }
    | {
          type: ModelActionType.ClearModel;
      }
    | {
          type: ModelActionType.AggregatedSetToModel;
          payload: {
              bindingPath: BindingPath;
              field: string;
              value: unknown;
          };
      }
    | { type: ModelActionType.redefineModel }
    | { type: ModelActionType.MergeRedefinedModel }
    | { type: ModelActionType.DropRedefinedModel };
